// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-fluid[data-v-8c384d4a]{max-height:100%;flex:0 0 auto}", ""]);
// Exports
module.exports = exports;
